import { useState, useEffect, useRef } from "react";
import { getProjects, getDestinationsBySelectedProject } from "./helpers";
import { useAppUrlGenerator } from "../hooks/useAppUrlGenerator";

export default (id, generateUrlType) => {
    const projectInputLabel = useRef(null);
    const [projectLabelWidth, setProjectLabelWidth] = useState(0);
    const [projects, setProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [selectedProject, setSelectedProject] = useState("");

    const [loadingDestinations, setLoadingDestinations] = useState(false);
    const [isDestinationsInputOpen, setIsDestinationsInputOpen] = useState(false);
    const [destinationsInputValue, setDestinationsInputValue] = useState("");
    const [destinations, setDestinations] = useState([]);
    const [selectedDestination, setSelectedDestination] = useState("");

    const [isUrlCopied, setIsUrlCopied] = useState(false);
    const {appUrl, generateUrl, isGenerateUrlButtonDisabled, setAppUrl} = useAppUrlGenerator(
        selectedProject._id, 
        selectedDestination.destinationId, 
        generateUrlType
    );

    useEffect(() => {
        if(projectInputLabel) {
            setProjectLabelWidth(projectInputLabel.current.offsetWidth);
        };
    }, [setProjectLabelWidth]);

    useEffect(() => {
        getProjects(id, setProjects, setLoadingProjects);
    }, [setProjects]);

    useEffect(() => {
        // Reset form on changing projects
        resetURL();
        setDestinationsInputValue("");
        setSelectedDestination("");

        if (selectedProject._id) { 
            getDestinationsBySelectedProject(selectedProject._id, setDestinations, setLoadingDestinations);
        };
    }, [selectedProject]);

    useEffect(() => {
        resetURL();
    }, [selectedDestination]);

    const resetURL = () => {
        setAppUrl(null);
        setIsUrlCopied(false);
    };

    /** Material UI Autocomplete handle functions */
    const handleGetOptionSelected = (destination, value) => {
        if (destination._id === value._id) {
            setSelectedDestination(destination);
            return true;
        };
    };

    const handleAutoCompleteOnChange = (_event, _newInput, reason) => {
        // Clean Selected Zone on clicking the Autocomplete clear button
        if (reason === "clear") {
            setSelectedDestination(""); 
        };
    };

    const handleAutocompleteInputChange = (_, newInputValue) => {
        setDestinationsInputValue(newInputValue);
    };
     /** END Material UI Autocomplete handle functions */

    const projectsProps = {
        projectInputLabel,
        projectLabelWidth,
        projects,
        selectedProject, 
        setSelectedProject,
        loadingProjects
    };

    const destinationsProps = {
        destinations,
        loadingDestinations,
        isDestinationsInputOpen, 
        setIsDestinationsInputOpen,
        destinationsInputValue,
    };

    const urlProps = {
        appUrl,
        isUrlCopied,
        setIsUrlCopied,
        isGenerateUrlButtonDisabled,
        generateUrl
    };

    return {
        handleGetOptionSelected,
        handleAutoCompleteOnChange,
        handleAutocompleteInputChange,
        urlProps,
        projectsProps,
        destinationsProps
    }
};